import Vue from 'vue'
import * as signalR from "@microsoft/signalr";
import store from "@/store";

const srClient = new signalR.HubConnectionBuilder()
    .withUrl(process.env.VUE_APP_SIGNALR_URL)
    .build();

srClient.start().then(function () {
    srClient.on("okunamayankelimesayisi", sayi => {
        store.commit('setBkCount', sayi)
    });
});

Vue.prototype.$signalr = srClient